export const quickstock = {
  quickstock: {
    legend: {
      stock: 'Available Stock',
      lowstock: 'Limited Stock',
      nostock: 'Out of Stock'
    },
    errors: {
      subcategories: "Server error, could not load the subcategories.",
      categories: "Server error, could not load the categories.",
      nostock: "Product without stock.",
    },
    notification: {
      title: 'Notify Me',
      alert: 'Be the first to know',
      alertunsubscribe: 'If you unsubscribe, you will not receive a notification when the product is back in stock. Do you wish to continue?',
      explanation: 'You will be notified as soon as the item is back in stock.',
      selectnotifications: 'Select how you would like to receive notifications.',
      email: 'Email',
      cancel: 'Cancel',
      subscribe: 'Subscribe',
      unsubscribe: 'Cancel the subscription',
    }
  }
};
